export const READ_ID_FIELD = 'readId';
export const CLIENT_ID_FIELD = 'clientId';
export const BY_CLIENT_ID_INDEX = 'byClientId';
export const BY_FOREIGN_KEY_INDEX = 'byForeignKey';
export const BY_ENTITY_INDEX = 'byEntity';
export const OPEN_CHARGE_CLIENT_ID_FIELD = 'openChargeClientId';
export const BY_OPEN_CHARGE_CLIENT_INDEX = 'byOpenChargeClient';

export const ACCESS_LIST_FIELDS = ['readers', 'teams', 'writers'];
